import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices/DomainServicesContext";
import { datasetQueryKeys } from "@/shared/domain/datasets/hooks";
import { eventQueryKeys } from "@/shared/domain/events/hooks";
import { fileQueryKeys } from "@/shared/domain/files/hooks";

import { CollectionRecord, CollectionResourceRef } from "../CollectionRecord";

import { collectionQueryKeys } from "./collectionQueryKeys";

interface AddToCollectionVariables {
  collectionId: string;
  resourceOwnerId: string;
  resources: CollectionResourceRef[];
}

export function useAddToCollection() {
  const { collections } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<CollectionRecord, Error, AddToCollectionVariables>({
    mutationFn: ({ collectionId, resourceOwnerId, resources }) =>
      collections.updateCollection(
        collectionId,
        { add_resources: resources },
        { resourceOwnerId },
      ),
    onSuccess: (record) => {
      queryClient.setQueryData(
        collectionQueryKeys.detail(record.collection_id),
        record,
      );
      void queryClient.invalidateQueries({
        queryKey: collectionQueryKeys.lists(record.org_id),
      });

      if (record.resource_type === "dataset") {
        void queryClient.invalidateQueries({
          queryKey: datasetQueryKeys.lists(),
        });
      } else if (record.resource_type === "file") {
        void queryClient.invalidateQueries({
          queryKey: fileQueryKeys.lists(record.org_id),
        });
      } else if (record.resource_type === "event") {
        void queryClient.invalidateQueries({
          queryKey: eventQueryKeys.listsScope(record.org_id, {
            type: "collection",
            id: record.collection_id,
          }),
        });
      }
    },
  });
}
